import { img } from "./minisites/shared";

export const CASES = [
  {
    key: "handwerk", label: "Handwerk", name: "Tischlerei Brandauer", tagline: "Maßmöbel, Küchen und Innenausbau aus Meisterhand.",
    imgs: ["craft1", "craft3", "craft2"], services: ["Maßmöbel", "Küchen", "Innenausbau"], cta: "Beratung anfragen",
    font: "'Archivo Variable', sans-serif", head: "'Archivo Black', sans-serif", bg: "#F6F3EE", ink: "#1E1A16", acc: "#B5562B",
  },
  {
    key: "gastro", label: "Gastronomie", name: "Gasthaus Lindenhof", tagline: "Regionale Küche, saisonale Karte und ein Garten unter alten Linden.",
    imgs: ["food3", "restin1", "food1"], services: ["Mittagsmenü", "Saisonkarte", "Feiern"], cta: "Speisekarte ansehen",
    font: "'Jost Variable', sans-serif", head: "'Cormorant Garamond', serif", bg: "#1F2A22", ink: "#F1EBDD", acc: "#D9B26F",
  },
  {
    key: "beratung", label: "Beratung", name: "Kessler Unternehmensberatung", tagline: "Strategie, Organisation und Begleitung für den Mittelstand.",
    imgs: ["office2", "office1", "desk2"], services: ["Strategie", "Organisation", "Begleitung"], cta: "Erstgespräch vereinbaren",
    font: "'IBM Plex Sans', sans-serif", head: "'Source Serif 4 Variable', serif", bg: "#F4F5F7", ink: "#14213D", acc: "#2F5D8C",
  },
];

export function OldSite({ c, narrow }) {
  const tile = { backgroundImage: "repeating-linear-gradient(45deg,#d9d4c4 0 2px,#e8e3d3 2px 10px)" };
  return (
    <div className="h-full w-full" style={{ ...tile, fontFamily: "'Times New Roman', Times, serif", color: "#222" }}>
      <div className="mx-auto h-full border-x-2 border-[#8a8a8a] bg-[#fffef6]" style={{ width: narrow ? "100%" : 960 }}>
        <div className="flex items-center gap-3 border-b-4 border-double border-[#666] bg-gradient-to-b from-[#7d9cc4] to-[#3c5d8a] px-3 py-3 text-white" style={{ height: narrow ? 92 : 110 }}>
          <img src={img(c.imgs[0])} alt="" className="h-14 w-14 border-2 border-white object-cover" />
          <div>
            <div style={{ fontFamily: "'Comic Sans MS', 'Comic Sans', cursive", fontSize: narrow ? 22 : 30, textShadow: "2px 2px 0 #000" }}>{c.name}</div>
            <div className="text-[12px] italic">*** Herzlich Willkommen auf unserer Homepage ***</div>
          </div>
        </div>
        <div className="flex flex-wrap gap-1 bg-[#ddd] px-2 py-1 text-[13px]">
          {["Startseite", "Über uns", ...c.services, "Gästebuch", "Links", "Kontakt"].map((x) => (
            <span key={x} className="text-[#0000EE] underline">{x}</span>
          ))}
        </div>
        <div className={narrow ? "p-3" : "grid grid-cols-[180px_1fr_200px] gap-3 p-3"}>
          {!narrow && (
            <div className="border border-[#999] bg-[#f3f0e0] p-2 text-[12px]">
              <b>Menü</b>
              <ul className="mt-1 list-disc pl-4 text-[#0000EE] underline">{c.services.map((s) => <li key={s}>{s}</li>)}</ul>
              <p className="mt-4">Besucher seit 2009:</p>
              <p className="bg-black px-1 font-mono text-[#0f0]">0 0 4 2 1 1</p>
            </div>
          )}
          <div className="text-[14px] leading-snug">
            <p className="text-center text-[18px] font-bold text-[#a00000]">{c.tagline}</p>
            <p className="mt-2">Wir freuen uns über Ihren Besuch. Hier finden Sie Informationen zu unserem Betrieb. Die Seite befindet sich im Aufbau!!</p>
            <div className="mt-2 flex gap-2">
              {c.imgs.map((k) => <img key={k} src={img(k)} alt="" className="h-[70px] w-[90px] border border-[#999] object-cover" />)}
            </div>
            <p className="mt-2 text-[12px]">Für Anfragen bitte anrufen oder ein Fax schicken. Öffnungszeiten auf Anfrage.</p>
            <table className="mt-2 w-full border border-[#999] text-[12px]"><tbody>
              {c.services.map((s) => <tr key={s}><td className="border border-[#999] px-1">{s}</td><td className="border border-[#999] px-1">mehr Infos &gt;&gt;</td></tr>)}
            </tbody></table>
          </div>
          {!narrow && (
            <div className="border border-[#999] bg-[#fff8c6] p-2 text-[12px]">
              <b className="text-[#a00000]">NEU!!!</b> Besuchen Sie auch unsere Seite in der Rubrik {c.services[1]}.
              <p className="mt-3 text-[11px]">Optimiert für 1024×768 und Internet Explorer.</p>
            </div>
          )}
        </div>
        <div className="mt-2 border-t border-[#999] p-2 text-center text-[11px] text-[#555]">© {c.name} · Impressum · Letzte Aktualisierung: 14.03.2011</div>
      </div>
    </div>
  );
}

export function NewSite({ c, narrow }) {
  const dark = c.key === "gastro";
  return (
    <div className="h-full w-full overflow-hidden" style={{ background: c.bg, color: c.ink, fontFamily: c.font }}>
      <div className="flex items-center justify-between px-6" style={{ height: narrow ? 92 : 110, paddingLeft: narrow ? 20 : 56, paddingRight: narrow ? 20 : 56 }}>
        <span style={{ fontFamily: c.head, fontSize: narrow ? 20 : 24 }}>{c.name}</span>
        {!narrow && <span className="flex gap-7 text-[14px] opacity-80">{c.services.map((s) => <span key={s}>{s}</span>)}<span>Kontakt</span></span>}
      </div>
      <div className={narrow ? "px-5" : "grid grid-cols-[1fr_1.1fr] gap-12 px-14 pt-6"}>
        <div className={narrow ? "pt-2" : "pt-10"}>
          <p className="text-[12px] uppercase tracking-[0.25em]" style={{ color: c.acc }}>{c.services.join(" · ")}</p>
          <h3 className="mt-4 leading-[1.02]" style={{ fontFamily: c.head, fontSize: narrow ? 38 : 58 }}>{c.tagline}</h3>
          <div className="mt-7 flex items-center gap-4">
            <span className="rounded-full px-6 py-3.5 text-[14px] font-semibold" style={{ background: c.acc, color: dark ? "#1F2A22" : "#fff" }}>{c.cta}</span>
            {!narrow && <span className="text-[14px] underline underline-offset-4 opacity-80">Mehr erfahren</span>}
          </div>
        </div>
        <div className={narrow ? "mt-7" : ""}>
          <img src={img(c.imgs[0])} alt="" className="w-full rounded-[18px] object-cover" style={{ height: narrow ? 250 : 420 }} />
          <div className="mt-3 grid grid-cols-2 gap-3">
            {c.imgs.slice(1).map((k) => <img key={k} src={img(k)} alt="" className="w-full rounded-[14px] object-cover" style={{ height: narrow ? 110 : 120 }} />)}
          </div>
        </div>
      </div>
    </div>
  );
}
